import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import { CATEGORIES } from "../../lib/api";

export const MenuList = ({ items }) => {
  const [active, setActive] = useState(CATEGORIES[0]);

  const filtered = useMemo(
    () => items.filter((i) => i.category === active),
    [items, active]
  );

  return (
    <div>
      <div className="flex flex-wrap gap-2.5" data-testid="menu-category-filters">
        {CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => setActive(cat)}
            data-testid={`menu-filter-${cat.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={`rounded-full border px-4 py-2 text-xs font-semibold uppercase tracking-[0.12em] transition-colors duration-200 md:text-sm md:normal-case md:tracking-normal ${
              active === cat
                ? "border-copper bg-copper text-charcoal"
                : "border-border text-cream/70 hover:border-copper hover:text-caramel"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="menu-items-grid">
        {filtered.map((item, i) => (
          <motion.article
            key={item.id}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: Math.min(i * 0.035, 0.4) }}
            data-testid={`menu-item-${item.id}`}
            className="group flex gap-4 rounded-2xl border border-border bg-card p-4"
          >
            {item.image ? (
              <div className="h-20 w-20 shrink-0 overflow-hidden rounded-xl">
                <img
                  src={item.image}
                  alt={item.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                />
              </div>
            ) : null}
            <div className="min-w-0 flex-1">
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-serif text-lg leading-snug text-cream">{item.name}</h3>
                <span className="shrink-0 text-sm font-semibold text-caramel" data-testid={`menu-item-price-${item.id}`}>
                  {item.price ? `₹ ${item.price}` : "₹ Price"}
                </span>
              </div>
              {item.description ? (
                <p className="mt-1.5 text-sm text-cream/60">{item.description}</p>
              ) : null}
              {item.calories != null && (
                <span className="mt-2.5 inline-block rounded-full border border-border px-2.5 py-1 text-[11px] uppercase tracking-[0.15em] text-muted-foreground">
                  {item.calories} kcal
                </span>
              )}
            </div>
          </motion.article>
        ))}
        {filtered.length === 0 && (
          <p className="text-sm text-muted-foreground" data-testid="menu-empty-state">
            Nothing here yet — check back soon.
          </p>
        )}
      </div>
    </div>
  );
};
